import {Component} from '@angular/core';
import {SubtenantListComponent} from './SubtenantListComponent';
import {ShellService, UiError} from '@edifecs/fp-ui-shell';

/**
 * Component for subtenant related errors.
 */
@Component({
    selector: 'app-subtenant-error',
    template: `
        <img src="/assets/fp-ui-lib/images/ic_error_500.svg" alt="Internal Error"/>
        <span class="msg">
                The current subtenant is either invalid or does not exists.
        </span>
        <button pButton type="button" class="p-button-outlined"
                label="Select Subtenant"
                (click)="onClickSelect()"></button>
    `,
    styles: [`
        :host {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .msg {
            font-size: 24px;
            color: #8697a7;
            padding: 0.5rem;
            margin-top: 60px;
            margin-bottom: 12px;
        }
    `],
    standalone: false
})
export class SubtenantErrorComponent {

    /**
     * Constructor
     * @param shellSvc Shell service
     */
    constructor(private readonly shellSvc: ShellService) {
    }

    /**
     * @internal
     * Handle select button click.
     */
    onClickSelect(): void {
        SubtenantListComponent.show(this.shellSvc);
    }

    /**
     * Show the error page for subtenant error
     * @param err Subtenant related error
     * @param shellSvc Shell service
     */
    public static show(err: Error, shellSvc: ShellService): void {
        shellSvc.showErrorPage(new UiError().setCause(err).setErrorComponent(SubtenantErrorComponent));
    }
}
